import React, { useState, useEffect } from "react";
import { post } from "../../api";
import { Box, CircularProgress, Typography } from "@mui/material";

const LazyImage = ({ src, alt, ...props }) => {
    const [imageSrc, setImageSrc] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        // Asynchronously load the image when the component mounts
        const loadImage = async () => {
            try {
                console.log(`Loading image from: ${src}`);
                // Simulate an async image fetch (e.g., fetch from an API or CDN)
                let result = await post("custom/getURLBlob", { url: src });
                if (result.isSuccess) {
                    setImageSrc(result.data);
                }
                setLoading(false);
            } catch (error) {
                console.error(`Error fetching image: ${error}`);
                setImageSrc("path/to/placeholder.png"); // Fallback image
            }
        };

        setLoading(true);
        setTimeout(() => {
            loadImage();
        }, 5);
    }, [src]);

    return (
        <>
            {loading ? (
                <Box
                    sx={{
                        display: "flex",

                        alignItems: "center",
                    }}>
                    <CircularProgress sx={{ color: "green !important", mr: "10px" }} size="15px" />
                    <Typography fontSize={"customFontSize.small"}>Loading image...</Typography>
                </Box>
            ) : (
                <img src={imageSrc} style={{ width: "100%" }} alt={alt} {...props} />
            )}
        </>
    );
};

export default LazyImage;
